import { put } from "redux-saga/effects";
import { serverRequest } from "../../actions";

export function* uploadv3(action) {
  // init & emit socket request
  var payload = {
    action: "portal/initUpload",
    page: action.page,
    name: action.name,
    data: action.data,
    size: action.size,
    assetId: action.assetId,
    mimeType: action.mimeType,
    formDataId: action.formDataId,
    componentId: action.componentId,
    uploadName: action.uploadName,
    _id: action._id,
  };

  yield put(serverRequest(payload));
}

export default uploadv3;
